﻿<template>
	<div class="IsBusyScreenComponent-container fade-in">
		<img src="@static/img/SaturnLogoAnim.svg" />
		<span :class="textClass">{{ text }}</span>
	</div>
</template>

<script>
	export default {
		name: 'IsBusyScreenComponent',
		props: ['text', 'delayToShowText'],
		data() {
			return {
				shouldDisplayText: false,
				textClass: 'fade-in invisible',
			};
		},
		computed: {},
		created() {
			if (this.delayToShowText) {
				setTimeout(() => {
					this.textClass = 'fade-in';
				}, this.delayToShowText);
			} else {
				this.textClass = 'fade-in';
			}
		},

		methods: {},
		components: {},
	};
</script>
<style>
	.IsBusyScreenComponent-container {
		background-color: rgba(0, 0, 0, 0.7);
		display: flex;
		flex-direction: column;
		justify-content: center !important;
		align-items: center !important;
		position: fixed;
		top: 0;
		right: 0;
		left: 0;
		bottom: 0;
		z-index: 1000000;
	}

	.IsBusyScreenComponent-container .fade-in.invisible {
		opacity: 0;
		animation: unset;
	}

	.IsBusyScreenComponent-container img {
		filter: invert(1);
		height: 139px;
		opacity: 0.6;
	}

	.IsBusyScreenComponent-container span {
		margin-top: 15px;
		font-size: 18px;
		color: var(--load-file-div-color-border);
		animation: blinker 2.5s ease infinite;
	}

	@keyframes blinker {
		50% {
			opacity: 0%;
		}
	}
</style>
